import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";

// assets
import AppLinkIcon from "assets/icons/app-link.svg";
import QnaIcon from "assets/icons/qna.svg";
import { theme } from "styles";

const RequestCard = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <button onClick={() => navigate("/all/app-link")}>
        <img src={AppLinkIcon} />
        <p>앱 연동 관리</p>
      </button>

      <div className="divider" />

      <button onClick={() => navigate("/all/qna")}>
        <img src={QnaIcon} />
        <p>문의사항 관리</p>
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 64px;
  background-color: #f3f7ff;
  padding: 4px 0;
  border-radius: 8px;

  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    outline: none;
    border: none;
    background-color: inherit;
  }

  div.divider {
    width: 1px;
    height: 24px;
    background: #d7dfef;
    border-radius: 2px;
  }

  p {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    margin-left: 10px;
    color: ${theme.colors["gray90"]};
  }
`;

export default RequestCard;
